import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    view?: string;
    extendedStyles?: CardContainerMultiColumnStyles;
    children?: any;
}

type Props = OwnProps;

export interface CardContainerMultiColumnStyles {
    cardDivider?: InjectableCss;
    gridItem?: GridItemProps;
    threeGridItem?: GridItemProps;
}

export const cardContainerMultiColumnStyles: CardContainerMultiColumnStyles = {
    gridItem: {
        width: [12, 12, 6, 4, 4],
        css: css`
            transition: all 1s ease-in-out;
            padding: 10px 22px;
            padding-left: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 6px;
                        `,
                        css`
                            padding: 6px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    threeGridItem: {
        width: [12, 12, 6, 3, 3],
        css: css`
            transition: all 1s ease-in-out;
            padding: 10px 22px;
            padding-left: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 6px;
                        `,
                        css`
                            padding: 6px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    cardDivider: {
        css: css`
            height: 100%;
            width: 100%;
            overflow: hidden;
        `,
    },
};

const CardContainerMultiColumn = ({ extendedStyles, view, children, ...otherProps }: Props) => {
    const [styles] = React.useState(() => mergeToNew(cardContainerMultiColumnStyles, extendedStyles));

    return (
        <GridItem {...(view === "List" ? styles.gridItem : styles.threeGridItem)} {...otherProps}>
            <StyledWrapper {...styles.cardDivider}>{children}</StyledWrapper>
        </GridItem>
    );
};

export default CardContainerMultiColumn;
